import React from 'react'
import styled from 'styled-components';
import { CorporateTheme } from '../../utils/themes';
import AdvanceSearchIcon from '../../assets/icons/AdvanceSearchIcon';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../middleware/ThemeContext';
import RolePermissionsIcon from '../../assets/icons/RolePermissionsIcon';

export const ActionButton = styled('button')(({ theme, disabled }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: CorporateTheme.spacing.sm,
  border: 'none',
  background: 'none',
  padding: `${CorporateTheme.spacing.sm} ${CorporateTheme.spacing.sm}`,
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? '0.5' : '1',
  color: theme.CorporateTheme.colors.textSecondary,
  fontSize: '14px',
  fontFamily: "'Raleway', sans-serif",
  fontWeight: 500,
  transition: 'all 0.2s',
  borderRadius: CorporateTheme.borderRadius,

  '&:hover': {
    color: theme.CorporateTheme.colors.accent,
    background: disabled ? 'transparent' : theme.CorporateTheme.colors.filterBG,
  },
}));

const RolePermissionButton = ({ disabled }: { disabled?: boolean }) => {
  const { theme } = useTheme();
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (disabled) return
    navigate('/home/roles-permissions');
  }
  return (
    <ActionButton onClick={handleNavigate} theme={theme} disabled={disabled}>
      <RolePermissionsIcon color={theme.CorporateTheme.colors.textSecondary} />
      Set Role Permission
    </ActionButton>
  )
}

export default RolePermissionButton